export default __webpack_public_path__ + "static/media/dra-guiomara.eacbbc2e.png";